<template>
    <div>
        <filter-label :canReset="Array.isArray(props.modelValue) && props.modelValue.length > 0"
            @reset="emit('update:modelValue', undefined)">
            <span :id="statusLabelId">Status</span>
        </filter-label>

        <div
            role="group"
            :aria-labelledby="statusLabelId"
            class="w-full grid grid-cols-2 gap-1 mb-1"
            data-test="checkbox-group"
        >
            <vx-checkbox-selection-item :active="statusFilter.draft"
                @selected="statusFilter = { ...statusFilter, draft: !statusFilter.draft }">
                Draft
            </vx-checkbox-selection-item>
            <vx-checkbox-selection-item :active="statusFilter.active"
                @selected="statusFilter = { ...statusFilter, active: !statusFilter.active }">
                Active
            </vx-checkbox-selection-item>
            <vx-checkbox-selection-item :active="statusFilter.suspended"
                @selected="statusFilter = { ...statusFilter, suspended: !statusFilter.suspended }">
                Suspended
            </vx-checkbox-selection-item>
            <vx-checkbox-selection-item :active="statusFilter.closed"
                @selected="statusFilter = { ...statusFilter, closed: !statusFilter.closed }">
                Closed
            </vx-checkbox-selection-item>
        </div>
    </div>
</template>

<script setup>
import { VxCheckboxSelectionItem } from '@voxie/frontend-components';
import { computed, useId } from 'vue';
import FilterLabel from '~/components/general/FilterLabel.vue';

const props = defineProps({
    modelValue: {
        type: Array,
        default: undefined,
    },
});

const emit = defineEmits(['update:modelValue']);

const statusLabelId = useId();
const statusFilter = computed({
    get() {
        const statuses = props.modelValue;
        return {
            draft: Array.isArray(statuses) && statuses.includes('draft'),
            active: Array.isArray(statuses) && statuses.includes('active'),
            suspended: Array.isArray(statuses) && statuses.includes('suspended'),
            closed: Array.isArray(statuses) && statuses.includes('closed'),
        };
    },
    set(newValue) {
        const selected = [];
        if (newValue.draft) {
            selected.push('draft');
        }
        if (newValue.active) {
            selected.push('active');
        }
        if (newValue.suspended) {
            selected.push('suspended');
        }
        if (newValue.closed) {
            selected.push('closed');
        }
        emit('update:modelValue', selected.length > 0 ? selected : undefined);
    },
});
</script>
